import * as fontLoader from "./modules/font-loader";
import { lazy as LazyLoader } from "./modules/lazy-loader";
import { init as embedLoader } from "./modules/lazy-embed";
import { init as hero } from "./modules/hero";
import { init as Maps } from "./modules/google-maps";
import { init as Menu } from "./modules/menu";
import { init as MegaMenu } from "./modules/mega-menu";
import { init as Slideshows } from "./modules/slideshows";
import { init as Brands } from "./modules/brands";
import { init as Form } from "./modules/rangeslider";
import { init as SearchBar } from "./modules/search-bar";
import { init as Tabs } from "./modules/tabs";
import { init as StickyHeader } from "./modules/sticky-header";
import { init as shortlist } from "./modules/shortlist";
import { init as Lightbox } from "./modules/lightbox";
import { init as BoatPage } from "./modules/boat-page";
import { init as BoatSearch } from "./modules/boat-search";
import { init as Testimonials } from "./modules/testimonials";

init();

function init() {
	fontLoader.load();
	StickyHeader();
	Menu();
	MegaMenu();
	LazyLoader().update();
	hero();
	Slideshows();
	Brands();
	Form();
	SearchBar();
	Tabs();
	embedLoader();
	Maps();
	shortlist();
	Lightbox();
	BoatPage();
	BoatSearch();
	Testimonials();
}
